const formControlLabelFormServiceQuestList = {
  YES: 'Conforme',
  NO: 'No conforme',
  NA: 'No se aplica',
  needAction: "Las acciones son obligatorias para las preguntas con respuesta 'No conforme' en este servicio",
  questionDescription: 'Descripción de la pregunta',
};

export default formControlLabelFormServiceQuestList;
